module.exports = __webpack_public_path__ + "img/phone.76c25dc8.png";